import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getUserData } from "@/services";
import { TUser } from "@/types/types";
import MainHeader from "@/components/shared/Header";

const MainLayout = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState<TUser | null>(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getUserData();
        if (data) {
          setUserData(data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full text-4xl">
        <Loader2 className="animate-spin mr-2 size-8" />
        Loading...
      </div>
    );
  }

  if (!userData) {
    return;
  }

  return (
    <div className="h-full">
      <MainHeader />
      <div className="">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
